import { IClassname } from '@/lib/shared/model/classname';

export const Cook = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5273 23.9473V27.6992C12.7543 28.8058 14.3478 29.4182 16.0001 29.4182C17.6523 29.4182 19.2458 28.8058 20.4728 27.6992V23.9498"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4728 5.77694C20.472 5.34414 20.4087 4.91373 20.2849 4.49902"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33252 14.3478C10.7606 13.3299 13.3672 12.8057 16 12.8057C18.6329 12.8057 21.2394 13.3299 23.6675 14.3478"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 26.2236V29.4184"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1663 20.9834C12.6831 21.4756 13.3694 21.7501 14.0831 21.7501C14.7968 21.7501 15.4832 21.4756 16 20.9834"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 20.9834C16.5168 21.4756 17.2032 21.7501 17.9169 21.7501C18.6306 21.7501 19.3169 21.4756 19.8338 20.9834"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7221 17.2777C14.5867 17.0656 14.3964 16.8942 14.1714 16.7817C13.9464 16.6692 13.695 16.6198 13.4442 16.6387C13.1933 16.6198 12.942 16.6692 12.717 16.7817C12.4919 16.8942 12.3016 17.0656 12.1663 17.2777"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8337 17.2777C19.6983 17.0656 19.508 16.8942 19.283 16.7817C19.0579 16.6692 18.8066 16.6198 18.5557 16.6387C18.3049 16.6198 18.0536 16.6692 17.8285 16.7817C17.6035 16.8942 17.4132 17.0656 17.2778 17.2777"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5272 26.7949L4.20095 29.1054C3.32019 29.4255 2.54072 29.9747 1.94287 30.6964"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4727 26.7949L27.799 29.1054C28.6797 29.4255 29.4592 29.9747 30.057 30.6964"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33247 9.12312V16.0137C7.25135 16.5964 7.6015 19.0704 8.97143 19.6915C9.16207 19.7783 9.32845 19.9107 9.45592 20.0769C9.58338 20.2432 9.66803 20.4382 9.7024 20.6448C10.2647 24.0236 14.2288 26.2229 16 26.2229C17.7724 26.2229 21.7378 24.0236 22.3027 20.6448C22.337 20.4382 22.4217 20.2432 22.5491 20.0769C22.6766 19.9107 22.843 19.7783 23.0336 19.6915C24.401 19.0691 24.7511 16.5938 23.6726 16.0124V9.1244C24.1863 8.78179 24.5759 8.28286 24.7839 7.7015C24.9919 7.12013 25.0071 6.48724 24.8273 5.89655C24.6475 5.30586 24.2823 4.78877 23.7857 4.42186C23.2891 4.05494 22.6875 3.85772 22.0701 3.85939C21.418 3.86064 20.7863 4.08626 20.281 4.49834C20.4061 4.91286 20.4707 5.34328 20.4727 5.77626"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33249 9.12335C8.00862 8.90921 7.7316 8.63156 7.51818 8.30722C7.30477 7.98288 7.15941 7.61859 7.0909 7.23642C7.0224 6.85426 7.03219 6.46216 7.11966 6.08388C7.20713 5.70561 7.37048 5.34902 7.5998 5.03573C7.82913 4.72243 8.11966 4.45894 8.4538 4.26122C8.78794 4.06349 9.15873 3.93565 9.54373 3.88543C9.92873 3.83521 10.3199 3.86366 10.6936 3.96905C11.0673 4.07444 11.4157 4.25459 11.7177 4.49857C11.5924 4.91301 11.5282 5.34352 11.5273 5.77649"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7178 4.49863C11.9958 3.57969 12.5622 2.77461 13.3332 2.20242C14.1041 1.63022 15.0387 1.32129 15.9988 1.32129C16.9589 1.32129 17.8935 1.63022 18.6644 2.20242C19.4354 2.77461 20.0018 3.57969 20.2798 4.49863"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5273 5.77694C11.5275 5.3441 11.5908 4.91359 11.7152 4.49902"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
